import { gql } from '@apollo/client'
import { META_FRAGMENT } from '../fragments/filters.fragment'
import { ABSTRACT_SEARCH_ITEM } from '../fragments/interface.fragment'
import { IAbstractSearchItemFragments } from '../fragments/content.fragment'
import { allContentFragments } from '../fragments/allContent.fragment'

export const GET_NETWORK_USERS_SUMMARY = gql`
  query GetNetworkSummary {
    publicUsersFollowing: publicUsers(
      input: {
        pageSize: 2
        page: 0
        filters: { type: FOLLOWING }
        orderBy: { value: CREATED_DATE, order: ASC }
      }
    ) {
      meta {
        ...MetaNode
      }
    }
    publicUsersFollowed: publicUsers(
      input: {
        pageSize: 2
        page: 0
        filters: { type: FOLLOWED }
        orderBy: { value: CREATED_DATE, order: ASC }
      }
    ) {
      meta {
        ...MetaNode
      }
    }
    userGroups {
      meta {
        count
      }
    }
  }
  ${META_FRAGMENT}
`

export const GET_PUBLIC_USERS = gql`
  query GetPublicUsers($input: PublicUsersInput!) {
    publicUsers(input: $input) {
      #      id
      meta {
        ...MetaNode
        orderBy {
          value
          order
        }
      }
      data {
        ...IAbstractSearchItem
        ...UserSearchItemNode
      }
    }
  }
  ${IAbstractSearchItemFragments.userSearchItemFragments.fragments.node}
  ${ABSTRACT_SEARCH_ITEM}
  ${META_FRAGMENT}
`

export const GET_USER_GROUPS = gql`
  query GetUserGroups($input: UserGroupInput) {
    userGroups(input: $input) {
      meta {
        ...MetaNode
      }
      data {
        id
        title
        avatarUrl
      }
    }
  }
  ${META_FRAGMENT}
`

export const GET_USER_NETWORK_ACTIVITY = gql`
  query GetUserNetworkActivity($input: NetworkActivityInput) {
    activity(input: $input) {
      meta {
        ...MetaNode
      }
      data {
        id
        content {
          ...AllContentItemNode
        }
        action
        date
        groupMeta {
          groupAction
          groupUrl
          groupName
        }
        user {
          id
          url
          firstName
          lastName
          imageUrl
        }
      }
    }
  }
  ${allContentFragments.fragments.node}
  ${ABSTRACT_SEARCH_ITEM}
  ${META_FRAGMENT}
`
